import Mustache from 'mustache'

import type { CmsTemplateData } from '@/lib/cms/template-data'

// Recursively renders every string in a fetched CMS document through
// Mustache, so content editors can reference dynamic values such as
// {{pricing.generalConsultation.total}} and {{socialProof.rating}} anywhere in Sanity content,
// including portable text spans.
export function renderCmsStrings<T>(
  value: T,
  templateData: CmsTemplateData,
): T {
  if (typeof value === 'string') {
    return renderString(value, templateData) as T
  }

  if (Array.isArray(value)) {
    return value.map((item) => renderCmsStrings(item, templateData)) as T
  }

  if (value !== null && typeof value === 'object') {
    const rendered: Record<string, unknown> = {}
    for (const [key, item] of Object.entries(value)) {
      rendered[key] = renderCmsStrings(item, templateData)
    }
    return rendered as T
  }

  return value
}

function renderString(value: string, templateData: CmsTemplateData): string {
  if (!value.includes('{{')) {
    return value
  }

  try {
    return Mustache.render(value, templateData)
  } catch (error) {
    // A malformed template in CMS content must never take a page down.
    console.warn('CMS templating failed for a content string', error)
    return value
  }
}
